import React from 'react';
import {
    ACTION_DOWN, ACTION_DOWN_LEFT, ACTION_DOWN_RIGHT,
    ACTION_LEFT, ACTION_RELAX, ACTION_RIGHT,
    ACTION_UP, ACTION_UP_LEFT, ACTION_UP_RIGHT,
    ACTION_CENTER
} from "../../tools/EyeActions";
import { getAvatarState } from "./avatarUtils";

const pupilOffsets = {
    [ACTION_LEFT]:       { x: -8, y: 0 },
    [ACTION_RIGHT]:      { x: 8, y: 0 },
    [ACTION_UP]:         { x: 0, y: -8 },
    [ACTION_DOWN]:       { x: 0, y: 8 },
    [ACTION_UP_LEFT]:    { x: -6, y: -6 },
    [ACTION_UP_RIGHT]:   { x: 6, y: -6 },
    [ACTION_DOWN_LEFT]:  { x: -6, y: 6 },
    [ACTION_DOWN_RIGHT]: { x: 6, y: 6 },
    [ACTION_CENTER]:     { x: 0, y: 0 },
    [ACTION_RELAX]:      { x: 0, y: 0 },
};

class DogAvatar extends React.Component {
    render() {
        const { offset, isRelax, containerSize, isBlink, pulseClass } = getAvatarState(this.props, pupilOffsets);

        return (
            <div className="avatar-holder" style={{ width: containerSize, height: containerSize * 0.85 }}>
                <svg viewBox="0 0 200 180" className="avatar-svg">
                    {/* Floppy ears */}
                    <ellipse cx="32" cy="80" rx="26" ry="45" fill="var(--avatar-primary)" stroke="var(--avatar-outline)" strokeWidth="2.5" transform="rotate(12 32 80)" />
                    <ellipse cx="32" cy="82" rx="16" ry="32" fill="var(--avatar-inner)" transform="rotate(12 32 82)" />
                    <ellipse cx="168" cy="80" rx="26" ry="45" fill="var(--avatar-primary)" stroke="var(--avatar-outline)" strokeWidth="2.5" transform="rotate(-12 168 80)" />
                    <ellipse cx="168" cy="82" rx="16" ry="32" fill="var(--avatar-inner)" transform="rotate(-12 168 82)" />

                    {/* Head */}
                    <circle cx="100" cy="72" r="62" fill="var(--avatar-primary)" stroke="var(--avatar-outline)" strokeWidth="2.5" />
                    <ellipse cx="100" cy="52" rx="22" ry="16" fill="var(--avatar-secondary)" opacity="0.25" />
                    <ellipse cx="100" cy="96" rx="28" ry="20" fill="var(--avatar-secondary)" />

                    {/* Eyes */}
                    <g className={isBlink ? 'avatar-eye-blink' : ''} style={{ transformOrigin: '76px 68px' }}>
                        <ellipse cx="76" cy="68" rx="17" ry={isRelax ? 2 : 16} fill="var(--avatar-eye-white)" stroke="var(--avatar-outline)" strokeWidth="1.5" style={{ transition: 'ry 0.3s ease' }} />
                        {!isRelax && (<>
                            <circle className={pulseClass} cx={76 + offset.x} cy={68 + offset.y} r="8" fill="var(--avatar-pupil)" style={{ transition: 'cx 0.2s ease, cy 0.2s ease' }} />
                            <circle cx={76 + offset.x - 2.5} cy={68 + offset.y - 3} r="3" fill="var(--avatar-eye-shine)" style={{ transition: 'cx 0.2s ease, cy 0.2s ease' }} />
                        </>)}
                    </g>
                    <g className={isBlink ? 'avatar-eye-blink' : ''} style={{ transformOrigin: '124px 68px' }}>
                        <ellipse cx="124" cy="68" rx="17" ry={isRelax ? 2 : 16} fill="var(--avatar-eye-white)" stroke="var(--avatar-outline)" strokeWidth="1.5" style={{ transition: 'ry 0.3s ease' }} />
                        {!isRelax && (<>
                            <circle className={pulseClass} cx={124 + offset.x} cy={68 + offset.y} r="8" fill="var(--avatar-pupil)" style={{ transition: 'cx 0.2s ease, cy 0.2s ease' }} />
                            <circle cx={124 + offset.x - 2.5} cy={68 + offset.y - 3} r="3" fill="var(--avatar-eye-shine)" style={{ transition: 'cx 0.2s ease, cy 0.2s ease' }} />
                        </>)}
                    </g>

                    {/* Eyebrows */}
                    <path d="M60 49 Q76 43 92 49" fill="none" stroke="var(--avatar-outline)" strokeWidth="2" strokeLinecap="round" />
                    <path d="M108 49 Q124 43 140 49" fill="none" stroke="var(--avatar-outline)" strokeWidth="2" strokeLinecap="round" />

                    {/* Nose & mouth */}
                    <ellipse cx="100" cy="92" rx="9" ry="7" fill="var(--avatar-nose)" />
                    <circle cx="96" cy="90" r="2.5" fill="var(--avatar-eye-shine)" opacity="0.5" />
                    <path d="M88 102 Q100 112 112 102" fill="none" stroke="var(--avatar-outline)" strokeWidth="1.5" strokeLinecap="round" />

                    {isRelax && <ellipse cx="100" cy="114" rx="7" ry="10" fill="#e88" stroke="var(--avatar-outline)" strokeWidth="1" />}
                </svg>
            </div>
        );
    }
}

export default DogAvatar;
